import React from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
    };
  }

  render() {
    return (
      <div id="detailSide" /*className="d-none"*/>
        <div className="detail-title">werkregels in detail</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/settings/werkregels/");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              werkregels
            </a>
          </div>
          <div className="float-right mt-0">
            <a
              id="edit-button"
              className="button bewerken"
              onClick={() => {
                this.props.history.push(
                  "/settings/werkregels/edit/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
            >
              Bewerken
            </a>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Field Name</div>
              <div className="box-title-2-active">
                {this.state.rowData.fieldName}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Alias</div>
              <div className="box-title-2">
                {this.state.rowData.alias}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  checked={this.state.rowData.visible ? true : false}
                  disabled
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Detail;
